import get from 'lodash/get';

import {
  CANCEL_NEW_CHAT_CREATION_REQUESTED,
  GET_NUMBER_OF_RECIPIENTS_SUCCESS,
  HANDLE_NEW_CHAT_CREATION_REQUESTED,
} from '../actionConstants';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case HANDLE_NEW_CHAT_CREATION_REQUESTED:
      return get(action, 'payload');
    case CANCEL_NEW_CHAT_CREATION_REQUESTED:
      return defaultState;
    case GET_NUMBER_OF_RECIPIENTS_SUCCESS:
      return {
        ...state,
        numberOfRecipients: get(action, 'payload.data.count'),
      };
    default:
      return state;
  }
};
